import * as React from 'react';
import { Popover } from 'antd';
import { inject } from 'mobx-react';
import { TooltipProps } from 'antd/lib/tooltip';
import { FeedbackPanel } from '@/components/index';
import RTCModel from '@/models/rtc';

export interface PopoverProps {
  RTCInstance?: RTCModel;
  type?: string;
  placement?: TooltipProps['placement'];
  align?: TooltipProps['align'];
  onVisibleChange?: (change: boolean) => void;
}

const Header: React.FC<PopoverProps> = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
  };
})(props => {
  const { RTCInstance, type = 'ready', children, placement, align, onVisibleChange } = props;
  const [feedbackPanelShow, reactSetFeedbackPanelShow] = React.useState<boolean>(false);
  const setFeedbackPanelShow = React.useCallback(
    (show: boolean) => {
      reactSetFeedbackPanelShow(show);
      onVisibleChange?.(show);
    },
    [onVisibleChange],
  );
  const blurCallBack = React.useRef<any>();

  React.useEffect(() => {
    if (feedbackPanelShow) {
      blurCallBack.current = () => {
        setFeedbackPanelShow(false);
      };
      document.addEventListener('click', blurCallBack.current);
    } else if (blurCallBack.current) {
      document.removeEventListener('click', blurCallBack.current);
    }
  }, [feedbackPanelShow, setFeedbackPanelShow]);

  return (
    <Popover
      content={<FeedbackPanel onSubmit={() => setFeedbackPanelShow(false)} type={type} />}
      placement={placement}
      align={align}
      overlayClassName="feedback-panel-popover"
      visible={feedbackPanelShow && !RTCInstance?.breakLineReconnecting}
    >
      {React.Children.only(children) &&
        React.cloneElement(children as any, {
          onClick(e: any) {
            setTimeout(() => {
              if (RTCInstance?.breakLineReconnecting) {
                setFeedbackPanelShow(false);
                return;
              }
              setFeedbackPanelShow(!feedbackPanelShow);
            }, 1);
            // e?.nativeEvent.stopImmediatePropagation();
          },
        })}
    </Popover>
  );
});

export default Header;
